<!-- NAVBAR START -->
<nav class="navbar navbar-expand-lg py-lg-3 navbar-dark">
    <div class="container">
      <!-- logo -->
      <a href="landing.html" class="navbar-brand mr-lg-5">
        <img
        src="../../../assets/images/logo-white.svg"
          alt=""
          class="logo-dark"
          height="30"
        />
      </a>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="mdi mdi-menu"></span>
      </button>

      <!-- menus -->
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <!-- left menu -->
        <ul class="navbar-nav mr-auto align-items-center">
          <li class="nav-item mx-lg-1">
            <a  class="nav-link "  [routerLink]="['/landing']" routerLinkActive="active" >Home</a>
          </li>
          <li class="nav-item mx-lg-1">
            <a class="nav-link" [routerLink]="['/features']" routerLinkActive="active">Features</a>
          </li>
          <li class="nav-item mx-lg-1">
            <a class="nav-link" [routerLink]="['/pricing']" routerLinkActive="active">Pricing</a>
          </li>
          <li class="nav-item mx-lg-1">
            <a class="nav-link" [routerLink]="['/faqs']" routerLinkActive="active">FAQs</a>
          </li>
          <li class="nav-item mx-lg-1">
            <a class="nav-link" [routerLink]="['/partners']" routerLinkActive="active">Partners</a>
          </li>
          <li class="nav-item mx-lg-1">
            <a class="nav-link" [routerLink]="['/contact']" routerLinkActive="active">Contact</a>
          </li>
        </ul>

        <!-- right menu -->
        <ul class="navbar-nav ml-auto align-items-center">
          <li class="nav-item mx-lg-1">
            <a class="nav-link" [routerLink]="['/login']" routerLinkActive="active">Sign Up</a>
          </li>
          <li class="nav-item mx-lg-1">
            <a class="nav-link" [routerLink]="['/login']" routerLinkActive="active">Sign In</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- NAVBAR END -->

  <!-- START HERO -->
  <section class="hero-section">
    <div class="container">
      <h1
        class="row text-white font-weight-normal hero-title align-items-center"
      >
        End User License Agreement
      </h1>
      <div class="row align-items-center text-white">
        <p>Last Updated: 7/7/2020</p>
      </div>
    </div>
  </section>
  <section class="py-5">
    <div class="container">
      <div class="row py-4">
        <div class="col-lg-12">
          <div class="row align-items-left">
            <p>
              <b>
                IMPORTANT — THIS SOFTWARE IS LICENSED, NOT SOLD, AND AVAILABLE
                FOR USE ONLY UNDER THE TERMS OF THIS END USER LICENSE
                AGREEMENT (“EULA”).</b
              >
            </p>

            <p>
              <b>
                YOU MAY NOT INSTALL OR USE THE SOFTWARE UNTIL AFTER YOU HAVE:
                (A) READ AND ACCEPTED THE TERMS OF USE; AND (B) READ AND
                ACCEPTED ALL OF THE EULA TERMS BELOW. INSTALLATION AND/OR USE
                OF THE SOFTWARE CONSTITUTES YOUR ACCEPTANCE OF THESE TERMS.</b
              >
            </p>
            <p><b>TERMS AND CONDITIONS</b></p>
            <ol>
              <li>
                <p><b>DEFINITIONS</b></p>
                <p>
                  For purposes of this EULA, the following terms shall have
                  the following meanings: Code shall mean computer programming
                  logic or instructions, including objects, object code,
                  source code, and/or embedded code, whether in human or
                  machine-readable format, compiled or uncompiled, whether
                  created, enhanced, or otherwise modified by AUTOACTION.
                  Documentation shall mean the user’s manuals and/or other
                  documentation provided to END USER along with the Software,
                  whether in tangible or electronic form. Intellectual
                  Property Rights shall mean all worldwide copyrights,
                  trademarks, service marks, trade secrets, patents, moral
                  rights, contract rights, and other proprietary rights.
                  Invoice shall mean the most recent invoice issued by
                  AUTOACTION to END USER. License Scope shall mean the scope
                  of the licenses granted to each of the different types of
                  the Software pursuant the Invoice, including any limitations
                  regarding number of servers, number of users, etc. The
                  scopes of the licenses to these different types of the
                  Software may differ, and the term License Scope shall be
                  used to collectively refer to the different scopes of all
                  the licenses to the Software. Service Bureau includes but is
                  not limited to application service providers, hosting
                  companies and Internet portals that would use the software
                  for the benefit of third party to third party transactions.
                  Software shall mean the software products that are owned by
                  Wise Information Technology, Inc. d/b/a AutoAction
                  (“AUTOACTION”) that are identified in the Invoice and the
                  Documentation for the Software.
                </p>
              </li>
              <li>
                <p><b>LICENSE GRANT</b></p>
                <p>
                  Subject to the terms and conditions of this Software EULA
                  and the payment of all applicable license fees, AUTOACTION
                  grants to END USER, and only END USER, a personal,
                  revocable, non-exclusive, non-transferable,
                  non-sublicensable, Code-only license to use the Software and
                  Documentation according to the License Scope, as identified
                  in this EULA and the Invoice, solely for END USER’s own
                  internal operations (including for operations performed on
                  behalf of END USER’s customers), utilizing END USER’s (or
                  its customers’) data. Fees are based on licenses purchased
                  and not on actual usage. The licenses purchased are not
                  cancelable, the fees paid are not refundable, and END USER
                  cannot decrease the quantity of licenses during the term of
                  END USER’s subscription, as listed on the Invoice. Further,
                  AUTOACTION reserves the right, without any advance notice to
                  END USER, to increase the amount of required license fees
                  not more than twice per calendar year. END USER acknowledges
                  and understands that only certain file types are supported
                  by the Software and are, in AUTOACTION’s sole discretion,
                  subject to change at any time and without notice to END
                  USER.
                </p>
              </li>
              <li>
                <p><b>RESTRICTIONS OF USE</b></p>
                <p>
                  END USER acknowledges that the Software and the Software’s
                  code sequence, structure, organization, and Code constitute
                  valuable trade secrets of AUTOACTION. Accordingly, END USER
                  agrees not to:
                </p>
                <ol type="a">
                  <li>
                    modify, adapt, alter, translate, or create a derivative
                    work of the Software unless END USER has requested, in
                    writing, permission from AUTOACTION and such permission
                    has been granted to END USER in writing from AUTOACTION;
                  </li>
                  <li>
                    sell, distribute, transfer, sublicense, lease, rent, or
                    loan the Software to any third party;
                  </li>
                  <li>
                    reverse engineer, decompile, disassemble, or otherwise
                    attempt to derive the Software’s Code;
                  </li>
                  <li>
                    use the Software in connection with the operations of a
                    Service Bureau, in a time-sharing environment, as a
                    subscription service, as part of a Software as a Service
                    (SAAS) model, or for the benefit of any third party; or
                  </li>
                  <li>
                    use the Software except as expressly allowed under Section
                    2 (License Grant).
                  </li>
                </ol>
                <p>
                  These restrictions are not intended to restrict END USER’S
                  ability to implement the Software but rather intended solely
                  to prohibit improper uses, alterations or modifications, or
                  other changes of the Software.
                </p>
              </li>
              <li>
                <p><b>COPIES</b></p>
                <p>
                  END USER shall be permitted to make a reasonable number of
                  copies of the Documentation and distribute such copies to
                  END USER’s internal user community. If a serial number,
                  password, license key or other security device is provided
                  to END USER for use with the Software, END USER may not
                  share or transfer such security device with any other third
                  party. Any other use of the Software by any third party,
                  except as provided in this EULA, is strictly forbidden and
                  is a breach of this EULA.
                </p>
              </li>
              <li>
                <p>
                  <b>DELIVERY, ACCEPTANCE, AND INSTALLATION</b>
                </p>
                <p>
                  The Software and Documentation will be shipped or otherwise
                  made available to END USER within a reasonable time
                  following acceptance of this EULA and the terms and
                  conditions associated herewith, and the submission to
                  AUTOACTION by END USER of any other necessary information.
                  The Software shall be deemed accepted upon the date of
                  delivery, or the date upon which the Software is made
                  available to END USER (“Delivery Date”). AUTOACTION reserves
                  the right, in its sole discretion, to determine on which
                  operating system types and versions it will allow
                  installation and support of the Software and may also, in
                  its sole discretion, determine minimum acceptable levels of
                  hardware and software protection, including, but not limited
                  to, uninterruptible battery backup power, surge protection,
                  anti-virus protection, and Internet firewall protection.
                  AUTOACTION may, in its sole discretion, change these
                  criteria at any time. At this time, the following
                  procedures, which may be changed, in AUTOACTION’s sole
                  discretion, at any time and without notice to END USER, must
                  be implemented and maintained at all times to provide an
                  acceptable environment for installation and operation of the
                  Software for all END USERs whose Software is installed
                  directly on END USER’s computers:
                </p>
                <ol type="a">
                  <li>
                    provide Internet access and an e-mail provider connection
                    to the computer;
                  </li>
                  <li>
                    back up the Software data after the close of each business
                    day and retain each of the resulting daily backup files
                    for at least one month because backup files are essential
                    for recovery from hardware and software failures that can
                    corrupt the Software;
                  </li>
                  <li>
                    provide reliable cabled, not wireless, Ethernet local area
                    network (“LAN”) connections between computer workstations
                    and servers used by AUTOACTION for installations on
                    desktop workstations;
                  </li>
                  <li>
                    provide clean and reliable electrical power using
                    uninterruptible power supply battery backups with surge
                    protection for all computers, printers, and network
                    equipment, including, but not limited to, Ethernet hubs,
                    routers and switches, used by AUTOACTION for installations
                    on desktop workstations;
                  </li>
                  <li>
                    provide up-to-date anti-virus software protection for all
                    computers running AUTOACTION and connected directly or
                    indirectly to the Internet;
                  </li>
                  <li>
                    provide genuine Microsoft Windows® operating system
                    components that are currently supported by Microsoft®,
                    purchased through Microsoft® authorized sales channels,
                    and that comply with the most current AUTOACTION operating
                    system requirements. This means that the Software cannot
                    be installed on or supported by computers that have
                    bootleg, counterfeit, grey-market, beta-test, or obsolete
                    operating system components; and
                  </li>
                  <li>
                    keep END USER’s computers current with all Microsoft®
                    updates for all Microsoft® software installed on END
                    USER’s computers, as well as any and all operating system
                    updates and upgrades required by AUTOACTION to continue
                    use of the Software.
                  </li>
                </ol>

                <p>
                  Provided that the criteria listed above are satisfied,
                  AUTOACTION will install the software with an installation CD
                  or remotely via the Internet. AUTOACTION will provide up to
                  six (6) total hours of initial training via Internet and
                  telephone conferencing at no additional charge. By mutual
                  agreement of END USER and AUTOACTION, the training may also
                  be conducted at the AUTOACTION headquarters in Houston,
                  Texas. Training will be provided for up to five (5)
                  employees of END USER. END USER must provide AUTOACTION
                  personnel with timely access to the computers and other
                  resources reasonably required to perform their installation
                  and training tasks. AUTOACTION will make reasonable attempts
                  to accommodate END USER’s scheduling preferences for a
                  training seminar.
                </p>
              </li>
              <li>
                <p>
                  <b>MAINTENANCE AND SUPPORT</b>
                </p>
                <p>
                  Maintenance of the Software, including, but not limited to
                  technical support and updates will be deemed to constitute
                  an integral part of the Software and will be subject to the
                  terms and conditions of this EULA.
                </p>
                <p>
                  After the initial installation, AUTOACTION may, at its sole
                  discretion, provide ongoing training via scheduled customer
                  training classes for END USER’s employees. The cost of such
                  classes for END USER will be agreed upon in writing by
                  AUTOACTIO and END USER. AUTOACTION will use commercially
                  reasonable efforts to provide assistance concerning the
                  proper use of the Software and the correction of problems
                  via telephone and the Internet at no charge during normal
                  business hours, provided all monthly license fee payments
                  are current and fully paid. In addition, on-site service,
                  support, or training may, in AUTOACTION’s sole discretion,
                  also be provided for an additional cost. The cost of such
                  on-site service, support, or training for END USER will be
                  agreed upon in writing by AUTOACTION and END USER. Examples
                  of on-site service, support, or training that may incur
                  additional costs or fees for the END USER include, but are
                  not limited to:
                </p>
                <ol type="a">
                  <li>
                    providing additional on-site training or consultation to
                    the customer and/or customer’s staff;
                  </li>

                  <li>
                    adding optional Software components and/or additional
                    desktop installations of the Software;
                  </li>

                  <li>
                    updating the currently installed version of the Software
                    to correct specific user problems;
                  </li>

                  <li>
                    upgrading the Software to a more recent version; and
                  </li>

                  <li>providing office and clerical services.</li>
                </ol>
                <p>
                  END USER is aware that AUTOACTION staff have access to use
                  an Admin account to provide setup and support services. All
                  support and service resulting from END USER’s failure to
                  comply with any of the obligations set forth in Section 5 of
                  this EULA will be billed to END USER at the rates set forth
                  in this Section 6. If END USER’s failure to comply with any
                  of the obligations contained in Section 5 of this EULA
                  necessitates reinstallation of the Software, or END USER
                  requests reinstallation of the Software, END USER agrees to
                  pay AUTOACTION for each company database that must be
                  re-installed plus additional cost for each desktop
                  installation of the Software that must be re-installed to
                  correct the problem (plus tax and any on-site trip charges).
                  Furthermore, END USER understands that failures to meet
                  these responsibilities may result in unrecoverable data
                  corruption and loss.
                </p>
                <p>
                  AUTOACTION’s service and support staff, whether operating
                  remote or on-site, are not responsible for the following
                  exclusions:
                </p>
                <ol type="a">
                  <li>
                    diagnosis or repair of END USER’s computer hardware,
                    printer hardware, or peripheral device problems;
                  </li>
                  <li>
                    diagnosis or repair of virus corruption, operating system
                    problems, or software or configuration problems not
                    directly related to or caused by the use of the Software,
                    including, but not limited to problems with Microsoft®
                    Excel;
                  </li>
                  <li>
                    Local Area Network (LAN) creation, configuration, and
                    troubleshooting;
                  </li>
                  <li>
                    Any items required to be provided by the END USER pursuant
                    to Section 5(a)-(g) of this EULA.
                  </li>
                  <li>
                    Change of user permissions or passwords for users at the
                    request of staff who are not the END USER or an approved
                    manager.
                  </li>
                </ol>
                <p>
                  It is the Licensee’s responsibility to find and obtain the
                  services of an information technology professional to
                  create, configure, diagnose and repair exclusions (a)-(c)
                  above.
                </p>
                <p>
                  If END USER desires to upgrade their plan or gain access to
                  any new, updated, or improved software platforms that
                  AUTOACTION currently offers or may offer in the future, END
                  USER understands that such upgrades and improvements may
                  require additional cost. AUTOACTION has no obligation to
                  provide any updates or to continue to provide or enable any
                  particular features and/or functionalities of the Software.
                  Further, AUTOACTION reserves the right to, in its sole
                  discretion, determine that any particular version of the
                  Software is no longer supportable and must be upgraded at
                  additional cost to the consumer, as specified in that
                  certain AUTOACTION pricing schedule, provided in connection
                  with the Invoice. END USER acknowledges that it is solely
                  responsible for any and all data uploaded, loaded, or
                  imported to the Software and AUTOACTION shall have no
                  responsibility for the accuracy, completeness, maintenance,
                  or correctness of such data. The sole obligation of
                  AUTOACTION is to reasonably assist, as described in this
                  Section 6, with technical issues relating to the Software.
                  AUTOACTION reserves the right to modify, suspend, or
                  discontinue, temporarily or permanently, the Software or any
                  service to which it connects, with or without notice and
                  without any liability to END USER. The Software may display,
                  include, use, or make available third-party content,
                  including, but not limited to data, information,
                  applications, and other product services, or provide links
                  to third-party websites or services, such as applications
                  that provide remote access to END USER’s computer systems
                  for support and service (“Third-Party Services”). END USER
                  acknowledges and agrees that AUTOACTION shall not be
                  responsible for any Third-Party Services, including their
                  accuracy, completeness, timeliness, validity, copyright
                  compliance, legality, decency, quality, or any other aspect
                  thereof. AUTOACTION does not assume, and shall not have, any
                  liability or responsibility for any Third-Party Services,
                  which are provided solely as a convenience, which access and
                  use are entirely at END USER’s own risk and subject to the
                  third-party’s terms and conditions.
                </p>
              </li>
              <li>
                <p><b>WARRANTIES</b></p>
                <ol type="a">
                  <li>
                    AUTOACTION DOES NOT WARRANT THAT END USER’S USE OF THE
                    SOFTWARE WILL BE ERROR-FREE, UNINTERRUPTED OR FREE FROM
                    ERRORS IN CODE. AUTOACTION WILL, AT ITS OWN EXPENSE AND AS
                    ITS SOLE OBLIGATION AND END USER’S EXCLUSIVE REMEDY FOR
                    ANY BREACH OF THIS WARRANTY, USE COMMERCIALLY REASONABLE
                    EFFORTS, WHICH MAY INCLUDE ADVISING END USER
                    ELECTRONICALLY OR TELEPHONICALLY HOW TO MAKE CORRECTIONS,
                    TO CORRECT ANY REPRODUCIBLE ERRORS IN THE SOFTWARE THAT
                    END USER REPORTS TO AUTOACTION IN WRITING. IF THE ERROR
                    CANNOT BE CORRECTED, AUTOACTION’S ENTIRE LIABILITY AND END
                    USER’S EXCLUSIVE FURTHER REMEDY SHALL BE, AT AUTOACTION’S
                    OPTION, EITHER (I) REPAIR OF THE SOFTWARE OR (II)
                    REPLACEMENT OF THE SOFTWARE.
                  </li>
                  <li>
                    END USER’s FAILURE TO IMPLEMENT OR TO ALLOW AUTOACTION TO
                    IMPLEMENT UPDATES AND IMPROVEMENTS IN A TIMELY MANNER, OR
                    FAILURE TO UPGRADE END USER’S OPERATING SYSTEM AS REQUIRED
                    FROM TIME TO TIME WITHIN A TIMELY MANNER, WITHOUT
                    AUTOACTION’S PRIOR WRITTEN CONSENT, WILL VOID SUCH
                    WARRANTY.
                  </li>
                  <li>
                    EXCEPT AS EXPRESSLY PROVIDED IN THIS EULA, THE SOFTWARE
                    AND DOCUMENTATION ARE PROVIDED “AS IS” AND AUTOACTION
                    MAKES NO WARRANTIES, EITHER EXPRESS OR IMPLIED, AS TO ANY
                    MATTER WHATSOEVER, INCLUDING, BUT NOT LIMITED TO,
                    INTERRUPTIONS AND ERRORS IN CODE, AND DISCLAIMS ALL
                    IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, ANY
                    IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A
                    PARTICULAR PURPOSE OR NONINFRINGEMENT. AUTOACTION DOES NOT
                    WARRANT THAT THE SOFTWARE WILL MEET END USER’S
                    REQUIREMENTS, WILL SATISFACTORILY MEET ANY LOCAL, STATE,
                    OR FEDERAL COMPLIANCE REQUIREMENTS, OR THAT OPERATION OF
                    THE SOFTWARE WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE
                    FROM ERRORS IN CODE. END USER SHALL HAVE SOLE
                    RESPONSIBILITY FOR THE ACCURACY, CORRECTNESS,
                    COMPLETENESS, AND MAINTENANCE OF THE INFORMATION FURNISHED
                    FOR PROCESSING, ANY USE MADE BY END USER OF THE DATA
                    OUTPUT BY THE SOFTWARE, AND ANY RELIANCE THEREON.
                  </li>
                </ol>
                <br />
              </li>
              <li>
                <p><b>TERM AND TERMINATION</b></p>
                <ol type="a">
                  <li>
                    <b>Term.</b> The term of this EULA will begin upon the
                    Delivery Date and shall be perpetual. This EULA will
                    govern regardless of whether END USER upgrades or
                    downgrades their subscription level or subscribes to any
                    future platforms or software by AUTOACTION, unless the
                    future platforms or software are governed by separate end
                    user license agreements.
                  </li>
                  <li>
                    <b>Termination.</b> Either party may terminate this EULA
                    upon the occurrence of a material breach by the other,
                    which material breach has not been cured within thirty
                    (30) days after receipt of written notice thereof. If END
                    USER breaches this EULA by failing to pay any amount due
                    and owing to AUTOACTION, or fails to comply with any
                    provision of this EULA, AUTOACTION may, without any
                    advance notice, immediately cease providing any and all
                    services to END USER and may revoke all licenses without
                    AUTOACTION incurring any liability to END USER for any
                    consequences arising therefrom. Upon termination of this
                    EULA for any reason, END USER shall pay AUTOACTION the pro
                    rata amount currently owed to AUTOACTION as of the date of
                    termination and shall immediately cease all use of the
                    Software, delete all copies of the Software and
                    Documentation from all electronic devices, and shall
                    destroy any physical copies of the Software and
                    Documentation. Termination of this EULA shall neither
                    limit any of AUTOACTION’s rights or remedies at law or in
                    equity in case of breach by END USER nor relieve END USER
                    of any duties, obligations, or liabilities under this
                    EULA.
                  </li>
                  <li>
                    <b>Effects of Termination.</b> Upon termination or
                    expiration of this EULA for any reason, any amounts owed
                    to AUTOACTION before such termination or expiration will
                    be immediately due and payable. All licensed rights
                    granted in this EULA will immediately cease to exist.
                    AUTOACTION’s obligation, if any, to provide maintenance
                    and support shall immediately cease. END USER must
                    promptly discontinue all use of the Software, erase all
                    copies of the Software from END USER’s computers, and
                    return to AUTOACTION or destroy all copies of the Software
                    and Documentation in END USER’s possession or control, and
                    certify in writing to AUTOACTION that END USER has fully
                    complied with these requirements.
                  </li>
                </ol>
                <br />
              </li>
              <li>
                <p><b>SURVIVAL</b></p>
                <p>
                  Section 1 (Definitions), Section 3 (Restrictions of Use),
                  Section 7 (Warranties), Section 8 (Term and Termination),
                  Section 9 (Survival), Section 10 (Confidentiality), Section
                  11 (Proprietary Rights), Section 12 (Infringement Claims),
                  Section 13 (Limitation of Liability), and Section 14
                  (General – with the exception of the “Inspections”
                  paragraph) will survive expiration or termination of this
                  EULA for any reason.
                </p>
              </li>
              <li>
                <p><b>CONFIDENTIALITY</b></p>
                <ol type="a">
                  <li>
                    Except as expressly allowed under this EULA, END USER will
                    not use or disclose any Software, Documentation, or any
                    idea, algorithm, Code, or trade secrets of AUTOACTION in
                    the Software or Documentation, except to the extent that
                    END USER can document that any such item:
                    <ol type="i">
                      <li>
                        becomes generally available for use and disclosure by
                        the public without any license or charge;
                      </li>
                      <li>
                        has been otherwise disclosed by AUTOACTION or a third
                        party without breach of a confidentiality obligation;
                      </li>
                      <li>
                        was independently developed by END USER without
                        reference to the Software or Documentation; or
                      </li>
                      <li>
                        is required to be disclosed by END USER by law or any
                        governmental authority, provided that END USER shall
                        notify AUTOACTION as soon as reasonably possible of
                        any such compelled disclosure and give AUTOACTION the
                        opportunity to defend against such disclosure or
                        obtain a protective order in connection therewith.
                      </li>
                    </ol>
                  </li>
                  <li>
                    END USER shall use commercially reasonable efforts, which
                    shall be no less stringent than those efforts that END
                    USER uses to protect END USER’s own software or other
                    similar proprietary property, to prevent the Software or
                    Documentation from being used by any employee, agent,
                    consultant or other person in any manner that would
                    violate this EULA.
                  </li>
                  <li>
                    END USER further agrees to use commercially reasonable
                    efforts to assist AUTOACTION in identifying and preventing
                    any use or disclosure of any Code of the Software, any
                    Documentation, or any of the ideas, algorithms, or trade
                    secrets contained therein, which are not expressly
                    authorized by this EULA.
                  </li>
                  <li>
                    Without limiting the foregoing obligation, END USER shall
                    advise AUTOACTION immediately in the event that END USER
                    learns or has reason to believe that any person who has
                    had access to the Software or Documentation or any portion
                    thereof, as a result of this EULA, has violated or intends
                    to violate the terms of this EULA.
                  </li>
                  <li>
                    END USER acknowledges and agrees that there is no adequate
                    remedy at law for a breach of this section, that such a
                    breach would irreparably harm AUTOACTION, and that
                    AUTOACTION shall, in the event of such a breach, be
                    entitled to equitable relief, including, without
                    limitation, injunctions, without the posting of any bond,
                    in addition to any other remedies.
                  </li>
                </ol>
              </li>
              <li>
                <p><b>PROPRIETARY RIGHTS</b></p>
                <p>
                  END USER has no ownership rights in the Software,
                  Documentation, or any reports or other output from or
                  generated by the Software. The Software and Documentation,
                  and all Intellectual Property Rights associated therewith,
                  are and will remain at all times the sole and exclusive
                  property of AUTOACTION. END USER has no right, title, or
                  interest in or to the Software or Document, or any
                  Intellectual Property Rights associated therewith, except as
                  expressly set forth in this EULA. Any feedback, comments,
                  ideas, improvements, or suggestions provided by END USER
                  with respect to the Software or Documentation shall remain
                  the sole and exclusive property of AUTOACTION, who shall be
                  free to use, copy, modify, publish, or redistribute the
                  feedback, comments, ideas, improvements, or suggestions for
                  any purpose and in any way without any credit or
                  compensation to END USER. Further, all designs, artwork, and
                  other digital media provided within the Software,
                  Documentation, or any reports or other output from or
                  generated by the Software shall remain the sole property of
                  AUTOACTION and END USER may not display, reproduce, alter,
                  sell, or use any of the designs, artwork, and other digital
                  media except through the Software, subject to the terms set
                  forth in this EULA. Upon AUTOACTION’s request, END USER
                  agrees, at AUTOACTION’s expense, to take such actions as
                  AUTOACTION may reasonably request to perfect AUTOACTION’s
                  ownership in the Software and Documentation. This EULA does
                  not grant END USER any rights in the trademarks or service
                  marks of AUTOACTION, all of which remain the exclusive
                  property of AUTOACTION. END USER may not alter or remove
                  trademarks, service marks, or other markings from the
                  Software or Documentation, their associated packaging, or
                  any reports or other output from or generated by the
                  Software. The Software and Documentation contain material
                  that is protected by patent laws, copyright laws, and
                  international treaty provisions. Accordingly, END USER may
                  not make copies of the same, except as expressly allowed
                  under this EULA. END USER shall maintain at all times all
                  patent and/or copyright notices provided on the Software and
                  Documentation, and their associated packaging. END USER
                  shall ensure that any permitted copy of the Software and
                  Documentation is produced only for END USER’s own benefit
                  and that it is clearly marked on the copy that such copy is
                  subject to copyright and confidentiality. END USER shall
                  further ensure that a written list is maintained of the
                  number of copies of the Software and the place of storage of
                  each copy. Copies of the Software and Documentation
                  constitute AUTOACTION’s property. All terms and conditions
                  of this EULA shall also apply to such copies.
                </p>
              </li>
              <li>
                <p><b>THIRD PARTY INFRINGEMENT CLAIMS</b></p>
                <ol type="a">
                  <li>
                    AUTOACTION shall pay those costs and direct damages
                    finally awarded against END USER in connection with any
                    claim by a third party that the Software directly
                    infringes any copyright or misappropriates any trade
                    secret recognized as such under applicable law (or those
                    costs and damages agreed to by AUTOACTION in a written
                    monetary settlement) and the reasonable costs of defense
                    incurred by END USER in connection therewith, including
                    reasonable attorneys’ fees and court costs, provided that:
                    <ol type="i">
                      <li>
                        END USER provides AUTOACTION with prompt written
                        notice of any such action or claim;
                      </li>
                      <li>
                        END USER will permit AUTOACTION to assume and control
                        the defense and settlement of any such action or
                        claim, at AUTOACTION’s expense;
                      </li>
                      <li>
                        END USER will not prejudice the defense of the action
                        or claim nor will END USER make any admission as to
                        liability nor compromise or agree to any settlement of
                        any such action or claim without the prior written
                        consent of AUTOACTION; and
                      </li>
                      <li>
                        END USER will provide AUTOACTION with such assistance,
                        documents, authority, and information as AUTOACTION
                        may reasonably require in relation to the action or
                        claim and defense or settlement thereof.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Notwithstanding the foregoing, AUTOACTION will have no
                    obligation under this Section 12 or otherwise with respect
                    to any infringement claim based upon:
                    <ol type="i">
                      <li>
                        any use of the Software not in accordance with this
                        EULA or for purposes not intended by AUTOACTION;
                      </li>
                      <li>
                        any use of the Software in combination with other
                        products, equipment, software, or data which END USER
                        is not authorized in writing to use in conjunction
                        with the Software;
                      </li>
                      <li>
                        any use of any release of the Software other than the
                        most current release made available to END USER;
                      </li>
                      <li>
                        any modification of the Software by any person other
                        than AUTOACTION;
                      </li>
                      <li>
                        END USER’s continued alleged infringing activity after
                        being informed of modifications that would have
                        avoided the alleged infringement; or
                      </li>
                      <li>
                        any combination of END USER’s use of the Software with
                        any other activities of END USER or others.
                      </li>
                    </ol>
                  </li>
                  <li>
                    If the Software becomes, or in AUTOACTION’s opinion is
                    likely to become, the subject of an infringement claim,
                    AUTOACTION may, at its option and expense, either:
                    <ol type="i">
                      <li>
                        procure for END USER the right to continue using the
                        Software;
                      </li>
                      <li>
                        replace or modify the Software so that it becomes
                        non-infringing; or
                      </li>
                      <li>
                        accept return of the Software and give END USER a pro
                        rata refund of license fees paid by END USER less a
                        reasonable allowance for the period of time END USER
                        used the Software.
                      </li>
                    </ol>
                  </li>
                  <li>
                    END USER shall defend, indemnify and hold AUTOACTION
                    harmless from and against all claims arising from the
                    activities described in any of the foregoing clauses
                    (b)(i)-(b)(vi). THIS SECTION 12 STATES AUTOACTION’S ENTIRE
                    LIABILITY AND END USER’S SOLE AND EXCLUSIVE REMEDY FOR
                    INFRINGEMENT CLAIMS AND ACTIONS.
                  </li>
                </ol>
              </li>
              <li>
                <p><b>LIMITATION OF LIABILITY</b></p>
                <p>
                  IN NO EVENT WILL AUTOACTION BE LIABLE FOR ANY CONSEQUENTIAL,
                  INDIRECT, EXEMPLARY, SPECIAL OR INCIDENTAL DAMAGES,
                  INCLUDING LOST PROFITS OR ANY DAMAGES ARISING FROM ANY DATA
                  LOSS OR CORRUPTION OF ANY KIND, ARISING FROM OR RELATING TO
                  THIS EULA INCLUDING THE USE OF THE SOFTWARE PROVIDED
                  HEREUNDER. AUTOACTION’S TOTAL CUMULATIVE LIABILITY IN
                  CONNECTION WITH THIS EULA AND THE SOFTWARE, WHETHER IN
                  CONTRACT OR TORT OR OTHERWISE, SHALL NOT EXCEED THE AMOUNT
                  OF THE LICENSE FEE PAID BY END USER FOR THE LICENSE TO WHICH
                  A SPECIFIC CLAIM APPLIES. END USER ACKNOWLEDGES THAT THE
                  LICENSE FEE REFLECTS THE ALLOCATION OF RISK SET FORTH IN
                  THIS EULA AND THAT AUTOACTION WOULD NOT ENTER INTO THIS EULA
                  WITHOUT THESE LIMITATIONS ON ITS LIABILITY.
                </p>
              </li>
              <li>
                <p><b>INDEMNIFICATION</b></p>
                <p>
                  Notwithstanding anything to the contrary contained herein,
                  END USER agrees to indemnify and hold AUTOACTION and its
                  parents, subsidiaries, affiliates, agents, suppliers,
                  partners, and licensors (if any) and their respective
                  officers and employees harmless from and against any
                  expenses and related costs, including, but not limited to,
                  court costs and reasonable attorneys’ fees, in connection
                  with any threatened or actual lawsuits, actions,
                  investigations, damages, judgments, or claims by any third
                  party, arising out of or relating to END USER’s use of the
                  Software and/or Documentation.
                </p>
              </li>
              <li>
                <p><b>GENERAL</b></p>
                <ol type="a">
                  <li>
                    <p><b>Assignments.</b></p>
                    <p>
                      END USER may not assign or transfer, by operation of law
                      or otherwise, any of END USER’s rights under this EULA
                      to any third party without AUTOACTION’s prior written
                      consent, such consent not to be unreasonably withheld.
                      Any attempted assignment or transfer in violation of the
                      foregoing will be void. AUTOACTION may, in its sole
                      discretion and without notice to or consent of END USER,
                      assign or transfer its rights and obligations under this
                      EULA.
                    </p>
                  </li>
                  <li>
                    <p><b>Export.</b></p>
                    <p>
                      END USER agrees not to export the Software outside the
                      United States without AUTOACTION’s prior written
                      consent, which consent will not be unreasonably
                      withheld. END USER further agrees to comply in all
                      respects with the applicable export laws and regulations
                      of the United States and not distribute or transfer the
                      Software in contravention of those laws and regulations,
                      including, but not limited to, exporting or re-exporting
                      into or to a nation or a resident of any U.S. embargoed
                      countries or to anyone on the U.S. Treasury Department’s
                      list of Specially Designated Nationals or the U.S.
                      Department of Commerce Denied Person’s List or Entity
                      List. END USER will defend, indemnify and hold harmless
                      AUTOACTION from and against any violation of such laws
                      or regulations by END USER or any of END USER’s agents,
                      officers, directors, or employees.
                    </p>
                  </li>
                  <li>
                    <p><b>Taxes.</b></p>
                    <p>
                      END USER will be responsible for payment of, and shall
                      not withhold from fees owed to AUTOACTION (including but
                      not limited to license fees and maintenance fees, if
                      applicable), all applicable sales, use, ad valorem, and
                      excise taxes; duties; and assessments based on END
                      USER’s use or possession of the Software. END USER shall
                      hold AUTOACTION harmless from all claims and liability
                      arising from END USER’s failure to pay such taxes.
                    </p>
                  </li>
                  <li>
                    <p><b>Inspections.</b></p>
                    <p>
                      END USER will for three (3) years maintain records
                      sufficient to verify the amounts owing to AUTOACTION
                      hereunder. END USER will permit AUTOACTION or its
                      representatives to review END USER’s relevant records
                      and inspect END USER’s facilities to ensure compliance
                      with this EULA. AUTOACTION will give END USER at least
                      two (2) business days advance notice of any such
                      inspection and will conduct the same during normal
                      business hours in a manner that does not unreasonably
                      interfere with END USER’s normal operations.
                    </p>
                  </li>
                  <li>
                    <p><b>Notices.</b></p>
                    <p>
                      All notices or other communications to AUTOACTION shall
                      be addressed to: Wise Information Technology, Inc. d/b/a
                      AutoAction, 10810 Katy Freeway, Suite 103, Houston, TX
                      77043, Attn: Chief Executive Officer. All notices,
                      consents and approvals under this EULA must be delivered
                      in writing by courier, by fax, or by certified or
                      registered mail, (postage prepaid and return receipt
                      requested), and will be effective upon the earlier of
                      receipt or when delivery is refused.
                    </p>
                  </li>
                  <li>
                    <p><b>Governing Law.</b></p>
                    <p>
                      This EULA will be governed by the laws of the State of
                      Texas without regard to conflict of laws provisions
                      thereof to the extent such principles or rules would
                      require or permit the application of the laws of any
                      jurisdiction other than those of the State of Texas.
                    </p>
                  </li>
                  <li>
                    <p><b> Arbitration.</b></p>
                    <p>
                      Subject to the provisions of Section 15(h) of this
                      Agreement, any controversy or claim arising out of or
                      relating to this contract, or the breach thereof, shall
                      be settled by arbitration administered by the American
                      Arbitration Association in accordance with its
                      Commercial Arbitration Rules and judgment on the award
                      rendered by the arbitrator(s) may be entered in any
                      court having jurisdiction thereof. Claims under
                      $1,000,000.00 shall be heard by a single arbitrator.
                      Within fifteen (15) days after the commencement of
                      arbitration requiring a single arbitrator, AUTOACTION
                      shall send to END USER, in writing via certified mail to
                      the address listed on END USER’s most recent invoice, a
                      list of three (3) potential arbitrators from which END
                      USER shall select the final arbitrator. If the claim
                      amount exceeds 1,000,000.00, the dispute shall be heard
                      by a panel of three arbitrators. Within fifteen (15)
                      days after the commencement of arbitration requiring a
                      panel of three arbitrators, each party shall select one
                      person to act as arbitrator and the two selected shall
                      select a third arbitrator within ten (10) days of their
                      appointment. If the arbitrators selected by the parties
                      are unable or fail to agree upon the third arbitrator,
                      the third arbitrator shall be selected by the American
                      Arbitration Association. The place of arbitration shall
                      be Houston, Texas. The arbitration shall be governed by
                      the laws of the State of Texas. Hearings will take place
                      pursuant to the standard procedures of the Commercial
                      Arbitration Rules that contemplate in person hearings.
                      The prevailing party shall be entitled to an award of
                      reasonable attorney fees. Except as may be required by
                      law, neither a party nor an arbitrator may disclose the
                      existence, content, or results of any arbitration
                      hereunder without the prior written consent of both
                      parties. The parties agree that they will evenly split
                      the cost of arbitrator compensation and administrative
                      charges and that failure or refusal of a party to pay
                      its required share of the deposits for arbitrator
                      compensation or administrative charges shall constitute
                      a waiver by that party to present evidence or
                      cross-examine witness. In such event, the other party
                      shall be required to present evidence and legal argument
                      as the arbitrator(s) may require for the making of an
                      award. Such waiver shall not allow for a default
                      judgment against the non-paying party in the absence of
                      evidence presented as provided for above.
                    </p>
                  </li>
                  <li>
                    <p><b> Remedies. </b></p>
                    <p>
                      Notwithstanding the provisions of Section 15(g) of this
                      Agreement, END USER acknowledges that the Software
                      contains valuable trade secrets and proprietary
                      information of AUTOACTION, that any actual or threatened
                      breach of Section 3 (Restrictions of Use) or Section 10
                      (Confidentiality) will constitute immediate, irreparable
                      harm to AUTOACTION for which monetary damages would be
                      an inadequate remedy, that AUTOACTION shall, in the
                      event of such a breach, be entitled to equitable relief,
                      including injunctive relief, without the posting of any
                      bond, in addition to any other remedies. Notwithstanding
                      the provisions contained in Section 15(g) of this EULA,
                      if any legal action is brought to enforce this EULA, the
                      prevailing party, as determined by a final,
                      non-appealable judgment or order, will be entitled to
                      receive its attorneys’ fees, court costs and other
                      collection expenses, in addition to any other relief it
                      may receive. The decision whether to arbitrate or pursue
                      other relief under the limited scope of this Section
                      15(h) shall be in the company’s sole discretion;
                      otherwise, the Company is bound to arbitrate all other
                      claims pursuant to Section 15(g) of this EULA.
                    </p>
                  </li>

                  <li>
                    <p><b> Waivers. </b></p>
                    <p>
                      All waivers must be in writing. Any waiver or failure to
                      enforce any provision of this EULA on one occasion will
                      not be deemed a waiver of any other provision or of such
                      provision on any other occasion.
                    </p>
                  </li>

                  <li>
                    <p><b> Severability. </b></p>
                    <p>
                      If any provision of this EULA is unenforceable, such
                      provision will be changed and interpreted to accomplish
                      the objectives of such provision to the greatest extent
                      possible under applicable law and the remaining
                      provisions will continue in full force and effect.
                      Without limiting the generality of the foregoing, END
                      USER agrees that Section 13 (Limitation of Liability)
                      and Section 14 (Indemnification) will remain in effect
                      notwithstanding the unenforceability of any provision in
                      Section 7 (Warranties).
                    </p>
                  </li>

                  <li>
                    <p><b> Confidentiality of EULA; Announcements.</b></p>
                    <p>
                      Neither party shall disclose any terms of this EULA to
                      anyone other than its attorneys, accountants and other
                      professional advisors except as required by law.
                      AUTOACTION shall be allowed to use END USER’s name on
                      its customer lists, so long as such lists are not
                      available to the general public and AUTOACTION discloses
                      the same to its present and potential customers after
                      execution of this EULA. “Potential customer” in this
                      section represents a specific customer that is
                      contemplating AUTOACTION’s products and services. For
                      any other use of END USER’s name, AUTOACTION shall
                      obtain written permission from END USER.
                    </p>
                  </li>
                  <li>
                    <p><b> Third Party Beneficiary.</b></p>
                    <p>
                      As the owner of the Intellectual Property Rights and the
                      confidential information for which END USER has
                      obligations under this EULA (including but not limited
                      to the Software and Documentation), AUTOACTION is an
                      intended third-party beneficiary to this EULA. Upon END
                      USER’s acceptance of this EULA, AUTOACTION will have the
                      right (and will be deemed to have accepted the right) to
                      enforce this EULA against END USER as a third-party
                      beneficiary of this EULA.
                    </p>
                  </li>

                  <li>
                    <p><b> Construction.</b></p>
                    <p>
                      The headings of Sections of the EULA are for convenience
                      and are not to be used in interpreting the EULA. As used
                      in the EULA the word “including’ means “including but
                      not limited to.”
                    </p>
                  </li>

                  <li>
                    <p><b> Counterparts.</b></p>
                    <p>
                      This EULA may be executed in counterparts, each of which
                      will be considered an original, but all of which
                      together will constitute the same instrument.
                    </p>
                  </li>

                  <li>
                    <p><b>Force Majeure.</b></p>
                    <p>
                      Neither party shall be liable for any delay in delivery
                      or nonperformance in whole of its obligations under this
                      EULA if prevented from doing so by a cause or causes
                      beyond its control, including, but not limited to, acts
                      of God or public enemy, failure of suppliers to perform,
                      fire, floods, storms, earthquakes, riots, strikes, war,
                      and restraints of government. The suspension of
                      performance shall be of no greater scope and no longer
                      duration than is reasonably required and the
                      non-performing party shall use reasonable efforts to
                      remedy its inability to perform.
                    </p>
                  </li>

                  <li>
                    <p><b>Data Storage. </b></p>
                    <p>
                      AUTOACTION will use industry standard data storage
                      systems and procedures to protect data belonging to END
                      USER. Such data will also be compartmentalized from
                      other users’ data.
                    </p>
                  </li>

                  <li>
                    <p><b>Malware. </b></p>
                    <p>
                      AUTOACTION and END USER agree that neither party will
                      negligently, knowingly, intentionally, or otherwise
                      upload, load, or import data containing malware to the
                      Software or otherwise damage the Software.
                    </p>
                  </li>

                  <li>
                    <p><b>Privacy. </b></p>
                    <p>
                      AUTOACTION collects, stores, maintains, and shares
                      information about END USER with AUTOACTION’s integration
                      partners. If END USER chooses to utilize one of
                      AUTOACTION’s integration partners, END USER may receive
                      a fee or other form of monetary compensation associated
                      therewith. By accepting this EULA, END USER agrees and
                      consents to the collection, storage, maintenance, and
                      sharing of END USER’s data by AUTOACTION, who makes no
                      representations or warranties regarding the privacy of
                      END USER’s information. AUTOACTION will use commercially
                      reasonable efforts to maintain the privacy of END USER’s
                      customers’ information. END USER understands and
                      acknowledges that END USER is responsible for any of END
                      USER’s customer data inputted into the Software,
                      including, but not limited to, payment information,
                      credit reporting information, and information provided
                      in connection with credit checks. AUTOACTION will not be
                      liable for any claims or damages arising from or out of
                      such customer data, including, but not limited to,
                      issues regarding data privacy, accuracy, and credit
                      reporting and disclosures.
                    </p>
                  </li>

                  <li>
                    <p><b>For U.S. Government End Users. </b></p>
                    <p>
                      The Software and Documentation are “Commercial Items” as
                      defined under 48 C.F.R. § 2.101, consisting of
                      “Commercial Computer Software” and “Commercial Computer
                      Software Documentation” as such terms are used under 48
                      C.F.R. § 12.212 or 48 C.F.R. § 227.7202, as applicable.
                      In accordance with 48 C.F.R. § 12.212 or 48 C.F.R. §
                      227.7202-1 through 227.7202-4, as applicable, the
                      Commercial Computer Software and Commercial Computer
                      Software Documentation are being licensed to U.S.
                      Government end users (a) only as Commercial Items and
                      (b) with only those rights as are granted to all other
                      end users pursuant to the terms and conditions provided
                      herein.
                    </p>
                  </li>

                  <li>
                    <p><b>No Further Obligations. </b></p>
                    <p>
                      END USER understands and acknowledges that AUTOACTION
                      has no further obligations other than those contained in
                      this agreement. END USER is solely responsible for
                      maintenance of END USER’s business, including, but not
                      limited to, payment of all governmental fees and taxes,
                      proper credit reporting disclosures, and compliance with
                      all laws, rules, and regulations.
                    </p>
                  </li>

                  <li>
                    <p><b>Entire Agreement. </b></p>
                    <p>
                      This EULA constitutes the entire agreement between the
                      parties regarding the subject hereof and supersedes all
                      prior or contemporaneous agreements, understandings, and
                      communication, whether written or oral; provided that
                      any non-disclosure agreement or confidentiality
                      agreement between AUTOACTION and END USER shall survive
                      the execution of this EULA. This EULA may be amended
                      only by a written document signed by duly authorized
                      representatives of both parties. A duly authorized
                      representative of AUTOACTION consists solely of either
                      the chief executive officer, president, or chief
                      financial officer thereof. If END USER issues or
                      responds to a purchase order, or similar document, in
                      connection with this EULA, any preprinted terms and
                      conditions appearing thereon shall not apply to or
                      become part of this EULA regardless of any statement to
                      the contrary contained therein.
                    </p>
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- END HERO -->

  <!-- START FOOTER -->
  <footer class="bg-dark py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <img
          src="../../../assets/images/logo-white.svg"
            alt=""
            class="logo-dark"
            height="30"
          />
          <p class="text-white-50 mt-4">
            Hyper makes it easier to build better websites with <br />
            great speed. Save hundreds of hours of design <br />
            and development by using it.
          </p>

          <ul class="social-list list-inline mt-3">
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-primary text-primary"
                ><span class="mdi mdi-facebook"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-danger text-danger"
                ><span class="mdi mdi-google"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-info text-info"
                ><span class="mdi mdi-twitter"></span
              ></a>
            </li>
            <li class="list-inline-item text-center">
              <a
                href="javascript: void(0);"
                class="social-list-item border-secondary text-secondary"
                ><span class="mdi mdi-github-circle"></span
              ></a>
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Company</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >About Us</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Documentation</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50">Blog</a>
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Affiliate Program</a
              >
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Apps</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Ecommerce Pages</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50">Email</a>
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Social Feed</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Projects</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Tasks Management</a
              >
            </li>
          </ul>
        </div>

        <div class="col-lg-2 mt-3 mt-lg-0">
          <h5 class="text-white">Discover</h5>

          <ul class="list-unstyled pl-0 mb-0 mt-3">
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Help Center</a
              >
            </li>
            <li class="mt-2">
              <a href="javascript: void(0);" class="text-white-50"
                >Our Products</a
              >
            </li>
            <li class="mt-2">
              <a
                href="privacy.html"
                class="text-white-50"
                >Privacy</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="mt-5">
            <p class="text-white-50 mt-4 text-center mb-0">
              © 2018 - 2020 Hyper. Design and coded by Coderthemes
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- END FOOTER -->